import React from 'react';
import CardsContent from "./cards-content.jsx";
import ChartContent from "./chart-content.jsx";

const ReportContent = ({ data, collapsed }) => {
    return (
        <>
            <CardsContent key={`cards-${collapsed}`} data={data}/>
            <ChartContent key={`line-${collapsed}`} data={data}/>
        </>
    );
};

export default ReportContent;